import React from "react";

export default function EmptyState() {
  return (
    <div className="empty-state">
      <img src="/images/empty state.png" alt="" />
    </div>
  );
}
